import { Outlet, createFileRoute } from "@tanstack/react-router";

function AuditsLayout() {
  return <Outlet />;
}

export const Route = createFileRoute("/$workspaceSlug/audits")({
  component: AuditsLayout,
});
